import React from 'react';
import styled from 'styled-components';

import Section from '../Section';

const CenterBanner = (props) => {
  const {
    title,
    content,
    actions,
    subtitle,
    className,
    isDark = false
  } = props;
  return (
    <StyledSection isDark={isDark} className={className}>
      {subtitle && <Subtitle>{subtitle}</Subtitle>}
      <Title isDark={isDark}>{title}</Title>
      {content && <Content isDark={isDark}>{content}</Content>}
      {actions && <Actions>{actions}</Actions>}
    </StyledSection>
  );
};

const StyledSection = styled(Section)`
  text-align: center;
  padding-top: 110px;
  padding-bottom: 200px;
  background-color: ${({ isDark }) => isDark && 'var(--blue-dark)'};
`;

const Title = styled.h1`
  color: ${({ isDark }) => (isDark ? 'var(--white)' : 'var(--blue-dark)')};
  font-size: var(--heading-size-xl);
  font-weight: var(--font-weight-black);
  line-height: var(--line-height-sm);
  margin-bottom: 15px;

  ${({ theme }) => `
  @media ${theme.mediumUp} {
    font-size: var(--heading-size-2xl);
    line-height: var(--line-height-sm);
  }
  `}
`;

const Content = styled.p`
  font-size: var(--font-size-lg);
  margin-bottom: 18px;
  max-width: 900px;
  margin: 0 auto 25px;
  color: ${({ isDark }) => isDark && 'var(--gray-medium)'};
`;

const Subtitle = styled.small`
  color: var(--gray-dark);
  font-size: var(--font-size-lg);
  display: block;
  margin-bottom: 5px;
`;

const Actions = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  > * {
    margin: 0 15px;
  }
`;

export default CenterBanner;
